import { client as lkClient } from "./network";

const SESSION_COOKIE = "pa_session_id";
const LK_VISIT_KEY = "pa_lk_visit_date";

function randomId() {
  if (typeof crypto !== "undefined" && crypto.randomUUID) {
    return crypto.randomUUID().replace(/-/g, "");
  }
  return `${Date.now().toString(36)}${Math.random().toString(36).slice(2, 14)}`;
}

function readCookie(name) {
  const match = document.cookie.match(new RegExp(`(?:^|; )${name}=([^;]*)`));
  return match ? decodeURIComponent(match[1]) : null;
}

function writeCookie(name, value, days = 365) {
  const maxAge = days * 24 * 60 * 60;
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/; max-age=${maxAge}; SameSite=Lax`;
}

export function getOrCreateSessionId() {
  let sessionId = readCookie(SESSION_COOKIE);
  if (!sessionId) {
    sessionId = randomId();
    writeCookie(SESSION_COOKIE, sessionId);
  }
  return sessionId;
}

export function canTrackClientLk() {
  const token = localStorage.getItem("token");
  const adminToken = localStorage.getItem("admin_token");
  const agencyToken = localStorage.getItem("agency_token");
  return Boolean(token) && !adminToken && !agencyToken;
}

export async function trackSignupVisit() {
  try {
    const session_id = getOrCreateSessionId();
    await lkClient.post("/api/v1/product-events/signup-visit", { session_id });
  } catch (_e) {
    // tracking must not block UX
  }
}

export async function trackLkVisit() {
  if (!canTrackClientLk()) return;
  const today = new Date().toISOString().slice(0, 10);
  if (localStorage.getItem(LK_VISIT_KEY) === today) return;
  try {
    await lkClient.post("/api/v1/product-events/lk-visit");
    localStorage.setItem(LK_VISIT_KEY, today);
  } catch (_e) {
    // ignore
  }
}

export async function trackWizardEvent(eventType, campaignId) {
  if (!canTrackClientLk()) return;
  try {
    await lkClient.post("/api/v1/product-events/wizard", {
      event_type: eventType,
      campaign_id: campaignId || null,
    });
  } catch (_e) {
    // ignore
  }
}

export const WIZARD_TAB_EVENTS = {
  "1": "wizard_tab_main",
  "2": "wizard_tab_mediaplan",
  "3": "wizard_tab_ads",
  "4": "wizard_tab_retargeting",
  "5": "wizard_tab_optimization",
  "6": "wizard_tab_audience",
};

export const CAMPAIGN_UPDATE_EVENTS = {
  basic_config: "wizard_tab_main",
  media_plan: "wizard_tab_mediaplan",
  retargeting: "wizard_tab_retargeting",
  optimization: "wizard_tab_optimization",
  auditory: "wizard_tab_audience",
  new_segment_id: "segment_enabled",
};
